import Vue from 'vue'
import App from "./App.vue";
import './registerServiceWorker'
import utils from "./utils";
import router from './router'
import '@/assets/css/tailwind.css';
import VueMasonry from 'vue-masonry-css'
import VueFormulate from '@braid/vue-formulate'
import VModal from 'vue-js-modal'
import VueTippy, { TippyComponent } from "vue-tippy";
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VuePlyr, {
  plyr: {
    controls: ['play', 'progress', 'mute']
  }
})

Vue.use(VueTippy);
// or
Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: false
      }
    }
  }
});

Vue.component("tippy", TippyComponent);
import "tippy.js/themes/light.css";
import "tippy.js/themes/light-border.css";
import "tippy.js/themes/google.css";
import "tippy.js/themes/translucent.css";
Vue.use(VModal);

Vue.use(VueFormulate)
Vue.use(VueMasonry);
const store = Vue.observable({
  step: 0, cards: [], distrikts: [], events: [], games: [], user: {cards: [], distrikt: null, scorecard: null}
});
Vue.prototype.$store = store;

Vue.config.productionTip = false
Vue.mixin(utils);

import Swiper, { Navigation, Pagination } from 'swiper';
import './assets/tailwind.css'

Swiper.use([Navigation, Pagination]);


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

